import { gql } from '@efficiently/client-core-graphql-models';

export const SEND_ORG_INVITES = gql(`
	mutation SendOrgInvites(
		$emails: [String!]!
		$accountId: String!
		$locationId: String!
		$roleId: String
		$client: LoginClient
	) {
		sendOrgInvites(
			emails: $emails
			accountId: $accountId
			locationId: $locationId
			roleId: $roleId
			client: $client
		) {
			existingEmails
			contactIds
		}
	}
`);

export const RESEND_ORG_INVITE = gql(`
	mutation ResendOrgInvite($contactId: String!, $client: LoginClient) {
		resendOrgInvite(contactId: $contactId, client: $client)
	}
`);

export const CANCEL_INVITE = gql(`
	mutation CancelOrgInvite($contactId: String!) {
		cancelContactInvite(contactId: $contactId)
	}
`);

export const REQUEST_INVITE_TO_PROJECT = gql(`
	mutation RequestInviteToProject($email: String!, $projectId: String!, $accountId: String) {
		requestInviteToProject(email: $email, projectId: $projectId, accountId: $accountId)
	}
`);

export const PROCESS_REQUEST_INVITE = gql(`
	mutation ProcessRequestInvite($requestId: String!, $isDecline: Boolean) {
		processRequestInvite(requestId: $requestId, isDecline: $isDecline) {
			email
			projectId
			userRoles {
				_id
				name
				label
				edition
				level
			}
		}
	}
`);
